export const pt = {
  heading: "Experiência",
  hint: "Abra um cargo para ver o detalhe",
  roles: [
    {
      title: "Back-end Developer",
      company: "Rocketseat",
      dateRange: "Fevereiro de 2025 - Julho de 2026",
      current: true,
      bullets: [
        "Sistemas backend: construí features de produção e serviços internos com Node.js, TypeScript, PostgreSQL, Redis, QStash e Docker.",
        "Engenharia de IA: projetei e desenvolvi workflow multi-agente para revisão de código, validação de requisitos, geração de feedback e atribuição de notas.",
        "Qualidade de plataforma: reestruturei uma suíte de testes automatizados legada, defini padrões de testes e criei uma skill específica do projeto para orientar futuras implementações.",
        "Ferramentas operacionais: entreguei dashboards internos e automações que reduziram trabalho manual e ampliaram a visibilidade de métricas de produto.",
      ],
    },
    {
      title: "Blockchain Developer",
      company: "BWS",
      dateRange: "Outubro de 2023 - Setembro de 2024",
      current: false,
      bullets: [
        "Arquitetura de APIs: construí e mantive APIs Nest.js integradas a múltiplas redes blockchain.",
        "Modelagem de domínio: apliquei DDD e outros padrões para melhorar infraestrutura interna, abstrações e manutenibilidade das APIs.",
        "Confiabilidade: aumentei cobertura de testes com Jest e configurei CI no GitHub para pipelines de teste das APIs.",
      ],
    },
    {
      title: "Full-Stack and Blockchain Engineer",
      company: "Freelance",
      dateRange: "Junho de 2022 - Outubro de 2023",
      current: false,
      bullets: [
        "Backend de produto: entreguei APIs em Nest.js e Fastify da ideação ao deploy para produtos completos de clientes.",
        "Camada de dados: modelei bancos SQL e NoSQL com Prisma e TypeORM.",
        "Deploy: provisionei máquinas em cloud e servi aplicações com NGINX na GCP e Digital Ocean.",
      ],
    },
    {
      title: "Back-End and Blockchain Engineer",
      company: "Softrends",
      dateRange: "Junho de 2020 - Junho de 2022",
      current: false,
      bullets: [
        "Ownership backend: evoluí de primeiro desenvolvedor para responsável por back-end, DevOps e blockchain.",
        "Desenvolvimento de APIs: construí APIs REST com Express.js, Adonis.js, Nest.js e outros frameworks, cobrindo autenticação, email SMTP, WebSocket, Cache, Blockchain, bancos SQL/NoSQL e outras integrações.",
        "Liderança técnica: liderei um pequeno time back-end no planejamento, escolhas técnicas, divisão de tarefas e entrega.",
        "Qualidade de serviço: apliquei princípios SOLID e outros padrões, suíte de testes, documentações e configurei infraestrutura cloud com NGINX para serviços em produção.",
      ],
    },
    {
      title: "Full-Stack Developer and Smart Contract QA",
      company: "Gravel Coin",
      dateRange: "Dezembro de 2018 - Dezembro de 2019",
      current: false,
      bullets: [
        "Base backend: construí uma API em Express.js e MySQL para uma plataforma de venda de token.",
        "Quality assurance: criei uma suíte de testes e corrigi smart contracts em Solidity com Mocha.js, Chai.js, Jest e Truffle.",
      ],
    },
  ],
};
